import { motion } from "framer-motion";

export const Benefits = (props: any) => {
  return (
    <section className="bg-white py-16 md:py-24">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="mx-auto max-w-4xl text-center space-y-4 px-4"
      >
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
          {props.title}
        </h2>

        <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto">
          {props.subTitle}
        </p>

        <div className="mx-auto h-[2px] w-14 bg-red-600"></div>
      </motion.div>

      {/* Grid */}
      <div className="mx-auto mt-16 grid max-w-6xl gap-6 px-4 sm:grid-cols-2 md:grid-cols-3">
        {props.benefitsList.map((item: any, idx: number) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: idx * 0.08 }}
            className="
              relative rounded-xl border border-gray-200 bg-white p-6
              shadow-sm transition-all duration-300 ease-out
              hover:shadow-md hover:border-gray-300 hover:-translate-y-[2px]
            "
          >
            {/* Accent Bar */}
            <span className="
              absolute left-0 top-0 h-full w-[5px] bg-red-600
              transition-opacity duration-300
              group-hover:opacity-100
            " />

            {/* Icon */}
            <div className="mb-4 text-red-600">
              {item.icon}
            </div>

            {/* Content */}
            <h3 className="text-base font-semibold text-gray-900 mb-2">
              {item.title}
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed">
              {item.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
